import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme, useTheme } from "@material-ui/core";
import { useAtomicStyles } from "../../styles";
import { memo, useCallback, useMemo } from "react";
import { actions } from "../../redux-store";
import { useDispatch } from "react-redux";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      borderRadius: 10,
      overflow: "hidden",
      padding: 0,
      height: 300,
      position: "relative",
    },
    imgPreview: {
      objectFit: "cover",
      width: "100%",
      maxHeight: 200,
      borderBottom: "1px solid black",
    },
    divContent: {
      padding: 10,
    },
    titlePreview: {
      fontWeight: "bold",
      fontSize: 25,
    },
    buttonAdd: {
      position: "absolute",
      top: "initial",
      left: "initial",
      bottom: 62,
      right: 20,
    },
  }),
);

const useProfilePreview = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const dispatch = useDispatch();
  const [t] = useTypedTranslations();

  const handleImageDialogOpen = useCallback(() => {
    dispatch(actions.setIsCreateMerchantBannerDialogOpen(true));
  }, [dispatch]);

  return {
    styles,
    classes,
    atomicStyles,
    handleImageDialogOpen,
    t,
  };
};

export { useProfilePreview as default };
